import { render, staticRenderFns } from "./NavBarLeftAcademy.vue?vue&type=template&id=53d1ff89&scoped=true&"
import script from "./NavBarLeftAcademy.vue?vue&type=script&lang=js&"
export * from "./NavBarLeftAcademy.vue?vue&type=script&lang=js&"
import style0 from "./NavBarLeftAcademy.vue?vue&type=style&index=0&id=53d1ff89&scoped=true&lang=css&"
import style1 from "./NavBarLeftAcademy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d1ff89",
  null
  
)

export default component.exports